import { useEffect, useRef, useState } from "react";
import { featureTimeline } from "@/mocks/chigua";

export default function TimelineSection() {
  const [activeIdx, setActiveIdx] = useState(-1);
  const nodesRef = useRef<(HTMLDivElement | null)[]>([]);

  useEffect(() => {
    const onScroll = () => {
      const idxs = nodesRef.current.map((el) => {
        if (!el) return -1;
        const r = el.getBoundingClientRect();
        return r.top < window.innerHeight * 0.7 ? 1 : 0;
      });
      const last = idxs.lastIndexOf(1);
      setActiveIdx(last);
    };
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <section id="timeline" className="py-14 md:py-20 bg-background-100 border-y border-background-200">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid lg:grid-cols-12 gap-8 lg:gap-10">
          {/* 说明 */}
          <div className="lg:col-span-4">
            <div className="lg:sticky lg:top-24">
              <div className="flex items-center gap-2 text-primary-600 text-sm font-medium mb-2">
                <span className="w-8 h-0.5 bg-primary-500 rounded-full"></span>
                完整时间线案例
              </div>
              <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 leading-snug">
                从起点到爆发
                <br />
                每一环都不遗漏
              </h2>
              <p className="mt-4 text-sm text-foreground-600 leading-relaxed">
                以一场典型商业融资风波为例,我们如何把碎片信息拼成可信的时间轴。每个节点都标注来源状态,
                让「来龙去脉」有迹可循。
              </p>

              <div className="mt-6 rounded-xl bg-background-50 border border-background-200 p-5">
                <h4 className="font-heading text-base font-bold text-foreground-900">该场复盘的信息分层</h4>
                <ul className="mt-4 space-y-3 text-sm text-foreground-600">
                  <li className="flex items-center gap-2">
                    <span className="w-2 h-2 rounded-full bg-secondary-500"></span>
                    已证实信息
                    <span className="ml-auto text-xs text-foreground-400">70%</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                    多方说法并存
                    <span className="ml-auto text-xs text-foreground-400">20%</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <span className="w-2 h-2 rounded-full bg-primary-500"></span>
                    待核实细节
                    <span className="ml-auto text-xs text-foreground-400">10%</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* 时间轴 */}
          <div className="lg:col-span-8 relative">
            <div className="relative pl-8 md:pl-12">
              {/* 竖线 */}
              <div className="absolute left-[7px] md:left-[11px] top-1 bottom-1 w-0.5 bg-background-300"></div>

              {featureTimeline.map((node, i) => {
                return (
                  <div
                    key={node.date}
                    ref={(el) => {
                      nodesRef.current[i] = el;
                    }}
                    className="relative mb-7 md:mb-8"
                  >
                    {/* 节点圆点 */}
                    <span
                      className={
                        "absolute -left-8 md:-left-12 top-5 w-4 h-4 rounded-full border-2 transition-colors " +
                        (i <= activeIdx
                          ? "bg-accent-500 border-background-50"
                          : "bg-background-100 border-background-400")
                      }
                    ></span>

                    <div
                      className={
                        "rounded-xl p-5 md:p-6 transition-all duration-500 " +
                        (i === activeIdx
                          ? "bg-background-50 border border-background-200"
                          : "bg-background-100/60 border border-transparent")
                      }
                    >
                      <div className="flex items-center gap-3 flex-wrap">
                        <span className="px-2.5 py-1 rounded-md bg-accent-100 text-accent-800 text-xs font-medium whitespace-nowrap">
                          {node.date}
                        </span>
                        <span className="text-xs text-foreground-400 whitespace-nowrap">
                          节点 {String(i + 1).padStart(2, "0")}
                        </span>
                      </div>
                      <h3 className="font-heading mt-3 text-lg font-bold text-foreground-900">{node.title}</h3>
                      <p className="mt-1.5 text-sm text-foreground-600 leading-relaxed">{node.desc}</p>
                    </div>
                  </div>
                );
              })}

              {/* 结尾 */}
              <div className="relative pl-0 mt-2 flex items-center gap-3">
                <span className="inline-flex items-center gap-2 px-4 py-2 rounded-md bg-primary-500 text-background-50 text-sm whitespace-nowrap">
                  <i className="ri-play-list-2-line" aria-hidden="true"></i>
                  更新中 · 持续跟进
                </span>
                <span className="hidden sm:block text-xs text-foreground-400">该复盘仍在收集中,欢迎提供线索</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}